import type { NextPage } from 'next'
import Head from 'next/head'
import { AdBanner } from '../components/articles'
import { MyChallenges, MyPins, MyRecommendations, MyTasks } from '../components/content'
import { Tour } from '../components/tour'
import { DocumentType } from '../lib/prismic'
import { useAnalyticsPageView, useIncompleteTasks, useSearchResponse, useUserContentsCompleted, useUserContentsEnrolled, useUserProfile, useUserTopicsSorted } from '../lib/state'

const MyCompass: NextPage = () => {
  const [userProfile] = useUserProfile()
  const { certifications, experience, professionalInterest, employmentType } = userProfile || {}
  const [incompleteTasks] = useIncompleteTasks()
  const [userTopicsSorted] = useUserTopicsSorted()
  const [enrolledIds] = useUserContentsEnrolled()
  const [completedIds] = useUserContentsCompleted()

  const loading = !(userProfile && incompleteTasks && userTopicsSorted && enrolledIds && completedIds)

  const [tasks] = useSearchResponse(
    loading
      ? {}
      : {
        hitsPerPage: 3,
        includeIds: ['falseID', ...(incompleteTasks ?? [])],
      }
  )
  const [recommendations] = useSearchResponse(
    loading
      ? {}
      : {
        excludeTypes: [DocumentType.CheckboxTask],
        excludeIds: [...(enrolledIds ?? []), ...(completedIds ?? [])],
        scoredTopicIds: userTopicsSorted,
        profile: { certifications, experience, professionalInterest, employmentType },
      }
  )
  const hits = [...(tasks?.hits ?? []), ...(recommendations?.hits ?? [])]

  useAnalyticsPageView({ title: 'My Compass', type: 'Personal Content' })

  return (
    <>
      <Head>
        <title>ACE Compass: My Compass</title>
        <meta name='description' content='' />
      </Head>
      <Tour />
      <div className='my-compass'>
        <MyTasks hits={hits.slice(0, 3)} loading={loading} />
        <MyChallenges />
        <MyPins isMyCompass={true} />
        <hr className='hr' />
        <MyRecommendations hits={hits.slice(3, 9)} loading={loading} />
      </div>
      <AdBanner />
    </>
  )
}

export default MyCompass
